import { AliasType, EntitySubmissionType } from '../gql/graphql';

import { graphql } from '../gql';
import { toPagination } from './utils';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const GET_INSURED_NAME = graphql(`
  query getInusredNames(
    $pagination: PaginationRequest
    $sort: PaginationSort
    $filters: EntityFilterInput
  ) {
    entities(pagination: $pagination, sort: $sort, filters: $filters) {
      edges {
        cursor
        node {
          uuid
          referenceId
          type
          status
          agency
          createdAt
          updatedAt
          aliases(filters: { source: PRIMARY, type: LEGAL_NAME }) {
            edges {
              cursor
              queryCursor
              node {
                uuid
                name
                type
                sources
                primary
              }
            }
          }
        }
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);
export interface IUseInsuredNamesQueryArg {
  pageNumber?: number;
  pageSize?: number;
  insuredName?: string;
  submissionFinalized?: boolean;
  enabled?: boolean;
}

export function useGetInsuredNames({
  pageNumber = 0,
  pageSize = 30,
  insuredName,
  submissionFinalized,
  enabled = true,
}: IUseInsuredNamesQueryArg) {
  const { loading, error, data, fetchMore } = useQuery(GET_INSURED_NAME, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort: { key: 'PRIMARY_LEGAL_NAME', order: 'ASC' },
      filters: {
        submissionType: EntitySubmissionType.Insured,
        submissionFinalized: submissionFinalized,
        contains: true,
        ...(insuredName && { alias: insuredName }),
      },
    },
    fetchPolicy: 'network-only',
    skip: !enabled,
  });

  const entities = useMemo(() => {
    if (!data?.entities?.edges) return [];
    return data.entities.edges.map((edge) => ({
      uuid: edge.node.uuid,
      referenceId: edge.node.referenceId ?? '',
      legalName:
        edge.node.aliases?.edges?.find(
          (alias) =>
            alias.node.type === AliasType.LegalName && alias.node.primary
        )?.node.name ?? '',
    }));
  }, [data]);

  const hasNextPage = data?.entities?.pageInfo?.hasNextPage ?? false;

  return {
    error,
    loading,
    data,
    entities,
    fetchMore,
    hasNextPage,
  };
}
